export default "__VITE_ASSET__CLO$_osj__"